import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { SanctionReason } from '@/types';

export type PendingSanction = {
  id: string;
  reason: SanctionReason;
  reason_label: string;
  eur_deducted: number;
  creators_deducted: number;
  top_tier_price: number;
  creator_username: string;
  notes: string;
  created: string;
};

type PendingRes = { items: PendingSanction[] };

const QK_PENDING = ['sanctions-pending'];

export function usePendingSanctions(enabled: boolean) {
  return useQuery({
    queryKey: QK_PENDING,
    queryFn: (): Promise<PendingRes> =>
      pb.send('/api/sanctions/pending', { method: 'GET' }),
    enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}

export function useAcknowledgeSanction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send<{ success: boolean }>(`/api/sanctions/${id}/acknowledge`, {
        method: 'POST',
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK_PENDING });
    },
  });
}
